module.exports = __webpack_public_path__ + "static/img/agent-2.bcc3e26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent-2.jpg
// module id = 3E70
// module chunks = 1